/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdviserSummaryDto } from './AdviserSummaryDto';
import type { ClientBasicInfoDto } from './ClientBasicInfoDto';
import type { EntityActivityDto } from './EntityActivityDto';
export type QuoteResponseDto = {
    /**
     * Quote UUID
     */
    id: string;
    /**
     * Client UUID
     */
    clientId: string;
    /**
     * Basic client information
     */
    client: ClientBasicInfoDto;
    /**
     * Local quote status
     */
    status: QuoteResponseDto.status;
    /**
     * Whether this quote is a standard new-business quote or a renewal modification quote
     */
    quoteClassification: QuoteResponseDto.quoteClassification;
    /**
     * When quoteClassification is RENEWAL, the renewal record this quote was created from
     */
    renewalId?: string;
    /**
     * Assigned adviser UUID
     */
    assignedAdviserId?: string;
    /**
     * Servicing adviser UUID
     */
    servicingAdviserId?: string;
    /**
     * Assigned adviser summary (UUID + name)
     */
    assignedAdviser?: AdviserSummaryDto | null;
    /**
     * Servicing adviser summary (UUID + name)
     */
    servicingAdviser?: AdviserSummaryDto | null;
    /**
     * Snapshot of header sent/received
     */
    header: Record<string, any>;
    /**
     * Snapshot of declarations sent/received
     */
    declarations?: Record<string, any>;
    /**
     * Ando quote reference (header.quote_id)
     */
    andoQuoteId?: string;
    /**
     * Timestamp of last successful Ando sync
     */
    andoSyncedAt?: string;
    /**
     * Last Ando sync error message (if any)
     */
    andoSyncError?: string;
    /**
     * True when the quote has at least one eOffer in BIND_FAILED status
     */
    eOfferBindFailed?: boolean;
    /**
     * ID of the bound policy linked to this quote (populated when status is BOUND)
     */
    boundPolicyId?: string | null;
    /**
     * Last request payload sent to Ando
     */
    lastAndoRequest?: Record<string, any>;
    /**
     * Last response payload received from Ando (or error body)
     */
    lastAndoResponse?: Record<string, any>;
    /**
     * Total premium
     */
    totalPremium?: number;
    /**
     * Total commission
     */
    totalCommission?: number;
    /**
     * Total tax
     */
    totalTax?: number;
    /**
     * Policy total tax (15% of net premium + fees)
     */
    policyTotalTax?: number;
    /**
     * Total net premium
     */
    totalNetPremium?: number;
    /**
     * Policy net total (ando net premium + admin fee + broker fee, ex GST)
     */
    policyNetTotal?: number;
    /**
     * Total tax on commission
     */
    totalTaxOnCommission?: number;
    /**
     * Admin fee
     */
    adminFee?: number;
    /**
     * Broker fee
     */
    brokerFee?: number;
    /**
     * Total (totalPremium + adminFee + brokerFee)
     */
    total?: number;
    /**
     * Per-risk premium details from Ando response (JSON array)
     */
    riskPremiums?: Record<string, any>;
    /**
     * Additional quote metadata (including cancellation details)
     */
    metadata?: Record<string, any>;
    /**
     * Quote risks
     */
    risks: Array<string>;
    /**
     * Referral notes (only when status is REFERRAL_SUBMITTED)
     */
    referralNotes?: Record<string, any>;
    /**
     * Activity entries for the quote
     */
    activities?: Array<EntityActivityDto>;
    /**
     * Created timestamp
     */
    createdAt: string;
    /**
     * Updated timestamp
     */
    updatedAt: string;
};
export namespace QuoteResponseDto {
    /**
     * Local quote status
     */
    export enum status {
        DRAFT = 'DRAFT',
        QUOTED = 'QUOTED',
        REFERRAL_SUBMITTED = 'REFERRAL_SUBMITTED',
        REFERRAL_ACTION_REQUIRED = 'REFERRAL_ACTION_REQUIRED',
        CANCELLED = 'CANCELLED',
        BOUND = 'BOUND',
        DECLINED = 'DECLINED',
    }
    /**
     * Whether this quote is a standard new-business quote or a renewal modification quote
     */
    export enum quoteClassification {
        STANDARD = 'STANDARD',
        RENEWAL = 'RENEWAL',
        MTA = 'MTA',
    }
}

